import { useContext } from 'react';

import { AbsoluteRouteDetector } from '../../contexts/AbsoluteRouteDetector';

export const useAbsoluteRoute = () => {
  const { currentRoute, params } = useContext(AbsoluteRouteDetector.Context);
  return { name: currentRoute, params };
};
